import React from 'react';
import { DataCard } from 'anf-core-react';
import { ShippingAddress, TmntText } from '../../Common';
import { stepFourProps } from './props';

export default function StepFourContent({ stepFour }) {
  const {
    exchangeShipToLocationTitle,
    exchangeShippingLocation,
    exchangeStandardShipping,
    exchangesStandardShippingTimeFrame,
  } = stepFour;
  return (
    <div className="rne-shipping-address-card" data-testid="rne-shipping-address-card">
      <DataCard
        headerTitle={exchangeShipToLocationTitle?.value}
        variant="boxed"
      >
        <ShippingAddress className="rne-shipping-address" shippingAddress={exchangeShippingLocation} />
        <hr className="rne-shipping-address-card__hr" />
        <div className="rne-shipping-address-note">
          <div className="h4">
            <TmntText tmnt={exchangeStandardShipping} />
          </div>
          <TmntText tmnt={exchangesStandardShippingTimeFrame} />
        </div>
      </DataCard>
    </div>
  );
}

StepFourContent.propTypes = {
  stepFour: stepFourProps.isRequired,
};
